import { useQuery } from '@tanstack/react-query'
import { Card, ErrorText, Spinner } from '@/components/ui'
import { formatLimitRub, formatRemainingRub, formatRub } from '@/lib/aiBudget'
import { apiUsers, usersKey } from './api'

export function UserUsage({ id }: { id: string }) {
  const stats = useQuery({ queryKey: [...usersKey, id, 'stats'], queryFn: () => apiUsers.stats(id) })
  return (
    <Card title="Расходы и использование ИИ" subtitle="Бюджет за текущий месяц по Москве. История по месяцам, функциям и сервисам.">
      {stats.isPending ? <Spinner /> : stats.isError ? <ErrorText error={stats.error} /> : <>
        {!stats.data.usage_available ? <p className="mb-3 text-sm text-muted">Учёт расходов пока недоступен.</p> : null}
        <dl className="grid grid-cols-2 gap-x-4 gap-y-5 text-sm sm:grid-cols-3">
          {[
            ['Месячный бюджет', formatLimitRub(stats.data.budget.limit_rub)],
            ['Подтверждённые расходы', formatRub(stats.data.budget.confirmed_rub)],
            ['Остаток', formatRemainingRub(stats.data.budget.remaining_rub, stats.data.budget.limit_rub)],
            ['В резерве', formatRub(stats.data.budget.reserved_rub)],
            ['Ожидают сверки', stats.data.budget.pending_count ?? 'неизвестно'],
          ].map(([label, value]) => <div key={label}>
            <dt className="text-muted">{label}</dt>
            <dd className="mt-1 font-semibold tabular-nums">{value}</dd>
          </div>)}
        </dl>
        {stats.data.usage.length ? <div className="mt-5 overflow-x-auto focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent" role="region" aria-label="История использования ИИ" tabIndex={0}>
          <table aria-label="Использование ИИ по месяцам" className="w-full min-w-[44rem] text-left text-sm [&_th]:px-2 [&_th]:py-3 [&_td]:px-2 [&_td]:py-3 [&_td]:tabular-nums">
            <thead><tr className="text-muted"><th scope="col">Месяц</th><th scope="col">Вид</th><th scope="col">Сервис</th><th scope="col">Вызовы</th><th scope="col">Входные токены</th><th scope="col">Выходные токены</th><th scope="col">Стоимость</th><th scope="col">Ожидает</th></tr></thead>
            <tbody>{stats.data.usage.map((row, index) => <tr key={`${row.month}-${row.kind}-${row.role}-${index}`} className="border-t border-border"><td className="whitespace-nowrap">{row.month}</td><td className="break-words">{row.kind}</td><td>{row.role.toUpperCase()}</td><td>{row.calls}</td><td>{row.prompt_tokens ?? 'неизвестно'}</td><td>{row.completion_tokens ?? 'неизвестно'}</td><td className="whitespace-nowrap">{formatRub(row.cost_rub)}</td><td>{row.pending_count}</td></tr>)}</tbody>
          </table>
        </div> : <p className="mt-5 text-sm text-muted">Истории расходов пока нет.</p>}
      </>}
    </Card>
  )
}
